/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { Card } from '@radix-ui/themes';

import { css, styled } from 'fierry/react';


const getSelectedStyle = ({ selected }) =>
{
  return selected && css`
    --base-card-surface-box-shadow: 0 0 0 1px var(--accent-a7);
  `;
};


export default styled(Card)`
  transition: box-shadow 100ms linear;

  ${props => getSelectedStyle(props)}

  &:hover
  {
    --base-card-surface-box-shadow: 0 0 0 1px var(--accent-a7);

    cursor: pointer;
  }

  &:active
  {
    --base-card-surface-box-shadow: 0 0 0 1px var(--accent-a8);

    transition-duration: 0s;
  }
`;
